import React from 'react';
import { useCommon } from '../../store/CommonContext';

import './Loader.css';

interface Props {}

const Loader: React.FC<Props> = () => {
  const {
    state: { configuration },
  } = useCommon();

  return (
    <div className="ui-widget-loader-wrapper">
      <div
        className="ui-widget-loader-wrapper-inner"
        style={{
          ...(configuration?.modalCornersRadius && { borderRadius: configuration.modalCornersRadius as string }),
        }}
      >
        <div className="ui-widget-loader" />
        <div className="ui-widget-loader-text">{'Processing...'}</div>
      </div>
    </div>
  );
};

export default Loader;
